export enum ChartAxisDirection {
    X = 'x',
    Y = 'y',
}
